import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { BundleCandidatesResponse, ErrorWrapper } from '@trade-platform/ui-shared';
import { OrderBundleCandidatesActions, OrderBundleCandidatesActionTypes } from './actions';

export type OrderBundleCandidatesState = RemoteData<BundleCandidatesResponse, ErrorWrapper>;
const initialState = notAsked<BundleCandidatesResponse, ErrorWrapper>();

export const orderBundleCandidatesReducer = (
    state: OrderBundleCandidatesState = initialState,
    action: OrderBundleCandidatesActions
): OrderBundleCandidatesState => {
    switch (action.type) {
        case OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD:
            return inProgress();
        case OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD_SUCCESS:
            return success(action.payload);
        case OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD_FAILURE:
            return failure(action.payload.error);
        case OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_RESET:
            return notAsked();
        default:
            return state;
    }
};
